import React from 'react';
import InitialsAvatar from './InitialsAvatar';
import { ExitIcon } from '../Iconset';
import MenuItem from '../menus/MenuItem';
import Menu from '../menus/Menu';
import MenuBar from '../menus/MenuBar';
import { LayoutOrientations } from '../../globals';
import { useTypedSelector } from '../../state/hooks';

export default function UserAccountMenu(props)
{
	const sessionInfo = useTypedSelector(state => state.userModule.sessionInfo);

	return (
		<div className="userAccountMenuConatiner" data-name={"user-account-menu-container"}>
			<MenuBar orientation={LayoutOrientations.Horizontal}>
				<Menu iconRenderer={<InitialsAvatar name={sessionInfo?.name || "User"} />} >
					<MenuItem
						label="Sign out"
						iconRenderer={<ExitIcon scale={0.75} />}
						onClick={() =>
						{
							console.log("logging out...");
							localStorage.removeItem("accessToken");
							window.location.reload();
						}}
					/>
				</Menu>
			</MenuBar>
		</div>
	);
}
